import ComboBase from '../base/ComboBase';
import { INPUTBASE_INNER_TEMPLATE } from '../base/InputBase';
import { COMBO_BASE_ARROW_TEMPLATE } from '../base/ComboBase';
import TimePanel from './TimePanel';
import InputBase from '../base/InputBase';

export const TIMEPICKET_PANEL_TEMPLATE = `
    <div ref="panelRef" v-if="!panelClosed"
        class="panel-body panel-body-noheader combo-panel combo-p f-column"
        :style="[panelStyle,{left:panelLeft+'px',top:panelTop+'px'}]">
        <TimePanel :value="valueState" :ampm="ampm" @change="onTimeChange($event)"></TimePanel>
        <div class="datebox-button f-row">
			<a href="javascript:;" class="datebox-button-a f-full" @click="onOk()">{{okText}}</a>
			<a href="javascript:;" class="datebox-button-a f-full" @click="closePanel()">{{closeText}}</a>
		</div>
    </div>
`;
export const TIMEPICKER_TEMPLATE = `
<span class="f-field timepicker" :class="baseClasses">
` + INPUTBASE_INNER_TEMPLATE + COMBO_BASE_ARROW_TEMPLATE + TIMEPICKET_PANEL_TEMPLATE + `
</span>
`;

export default {
    name: 'TimePicker',
    template: TIMEPICKER_TEMPLATE,
    extends: ComboBase,
    components: {
        TimePanel
    },
    props: {
        value: String,
        ampm: {
            type: Array,
            default: () => ['am', 'pm']
        },
        hour24: {
            type: Boolean,
            default: () => false
        },
        hourDistance: {
            type: Array,
            default: () => [20, 50]
        },
        closeText: {
            type: String,
            default: () => window.Locale.t('DateBox.closeText', 'Close')
        },
        okText: {
            type: String,
            default: () => window.Locale.t('DateBox.okText', 'Ok')
        },
        editable: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            selectingValue: null
        }
    },
    mounted() {
        this.setValue(this.value)
    },
    methods: {
        setValue(value) {
            this.selectingValue = value;
            this.textState = value;
            InputBase.methods.setValue.call(this, value);
        },
        onOk() {
            this.setValue(this.selectingValue);
            this.closePanel();
        },
        onTimeChange(value) {
            this.selectingValue = value;
        }
    }
}